import { UserWrapper } from "@core";
import { env } from "../../../environments/environment.js";

export class MonoprixUserWrapper extends UserWrapper {

  /**
   * user has consent for analytics cookies
   * (use google analytics)
   * @returns boolean
   */
  analyticsAllowed() {
    return true;
  }

  /**
   * returns the domain for analytics
   */
  analyticsDomain() {
    return env.monoprix.domain;
  }

  /**
   * user has consent for "function" cookies or profiling cookies
   * (use user id)
   * @returns boolean
   */
  profilingAllowed() {
    // findLastIndex is not supported by firefox and chrome below 96
    const lastEventIndex = [...window.dataLayer].reverse().findIndex(e => e.event === 'OneTrustLoaded');
    if (lastEventIndex === -1) { return false }

    // The index found is based on datalayer.reverse() so it's the opposite of the one we want
    return window.dataLayer[window.dataLayer.length - 1 - lastEventIndex].OnetrustActiveGroups?.includes('C0003');
  }

  /**
   * @return true if user is logged
   */
  isUserLogged() {
    throw new Error("You must implement 'isUserLoged' for this retailer");
  }

  /**
   * @returns user id for retailer
   */
  getUserId() {
    if(window.location.href.includes('ma-liste')) {
      return window.__INITIAL_STATE__.session.metadata.customerId ? window.__INITIAL_STATE__.session.metadata.customerId + '-nonal' : null;
    }
    else {
      return window.__INITIAL_STATE__.session.metadata.customerId;
    }
  }
}
